/* global jQuery */
void (function main() {
	const $ = jQuery;
	const backToTopThresholdPx = 300;
	const $desktopBreakpoint = 1280;

	$.fn.inViewportHorizontal = function inViewportHorizontal() {
		const elementPadding = 1.5;
		const elementLeft = $(this).offset().left;
		const elementWidth = $(this).outerWidth(true);
		const viewportLeft = $(window).scrollLeft();

		return (
			elementLeft + elementWidth * elementPadding <=
			viewportLeft + $(window).width()
		);
	};

	function subMenuPositioning() {
		if ($(window).width() > $desktopBreakpoint) {
			$('ul.menu.menu__submenu').each((index, subMenu) => {
				$(subMenu).attr(
					'data-visible',
					$(subMenu).inViewportHorizontal(),
				);
			});
		}
	}

	$(document).ready(() => {
		// Global variables
		const $mainNav = $('#siteNav');
		const $navToggle = $('#navToggle');
		const $navToggleText = $navToggle.find('.toggle-text');

		subMenuPositioning();

		// When clicking the main nav toggle button...
		$navToggle.on('click', (event) => {
			event.preventDefault();

			// Find initial nav state
			const navIsHidden = $mainNav.attr('aria-hidden') === 'true';

			// Find what the current state of nav should be
			let newNavState;
			if (navIsHidden) {
				newNavState = {
					label: 'Hide Menu',
					expanded: true,
					hidden: false,
				};
				$navToggleText.text('Close');
			} else {
				newNavState = {
					label: 'Show Menu',
					expanded: false,
					hidden: true,
				};
				$navToggleText.text('Menu');
			}

			// Updating new main nav state
			$navToggle.attr({
				'aria-label': newNavState.label,
				'aria-expanded': newNavState.expanded,
			});
			$mainNav.attr({
				'aria-hidden': newNavState.hidden,
				'data-current-level': 0,
			});

			// Hide all open menus
			$mainNav
				.find('.menu[aria-hidden="false"]')
				.attr({ 'aria-hidden': true });
		});

		// When clicking a link in the main nav...
		$mainNav.on('click', '.menu-link', (event) => {
			// Find the clicked link, menu level of the clicked link, and the menu that the link is linking to

			const $menuLink = $(event.target).closest('.menu-link');
			let linkLevel = $menuLink.attr('data-level');
			const linkMenuId = $menuLink.attr('data-page');
			const $activeSubMenu = $(`.menu[data-page="${linkMenuId}"]`);

			if ($(event.target).hasClass('submenu-toggle')) {
				event.preventDefault();
				linkLevel = $(event.target)
					.parents('.menu-item')
					.attr('data-level');
			}

			// Find the initial nav state of the linked menu
			const subMenuHidden = $activeSubMenu.attr('aria-hidden') === 'true';

			// Update the active menu level of the main nav
			$mainNav.attr({ 'data-current-level': linkLevel });

			// Update the active submenu's visibility
			$activeSubMenu.attr({
				'aria-hidden': !subMenuHidden,
			});
		});

		// scroll body to 0px on click
		const scrollAnimationSpeed = 800;
		$('#backToTop').click(() => {
			$('body,html').animate(
				{
					scrollTop: 0,
				},
				scrollAnimationSpeed,
			);
			return false;
		});

		if ($(window).scrollTop() > backToTopThresholdPx) {
			$('.back-to-top').addClass('visible');
		} else {
			$('.back-to-top').removeClass('visible');
		}
	});

	$(window).resize(() => {
		subMenuPositioning();
	});

	$(window).scroll(() => {
		if ($(window).scrollTop() > backToTopThresholdPx) {
			$('.back-to-top').addClass('visible');
		} else {
			$('.back-to-top').removeClass('visible');
		}
	});

	// Find FAQs on the page
	const $faqContainers = $('.accordion--question-group');
	// With each FAQ container...
	$faqContainers.each((index, faq) => {
		const $faq = $(faq);
		let lastQuestionId;

		// On page load...
		$(document).ready(() => {
			// Set intial height based on open answer
			const initialOpenQuestion = $faq
				.find('.accordion--question[aria-expanded="true"]')
				.attr('data-question');
			const $currentAnswer = $faq.find(
				`.accordion--answer[data-question=${initialOpenQuestion}]`,
			);
			$faq.css('min-height', $currentAnswer.outerHeight());

			// Update view state
			lastQuestionId = initialOpenQuestion;
		});

		// When clicking FAQ question...
		$faq.on('click', '.accordion--question', (event) => {
			// Find question state and associated answer state
			const $faqQuestions = $faq.find('.accordion--question');
			const $faqAnswers = $faq.find('.accordion--answer');
			const $currentQuestion = $(event.target).closest(
				'.accordion--question',
			);
			const currentQuestionId = $currentQuestion.attr('data-question');
			const currentQuestionExpanded =
				$currentQuestion.attr('aria-expanded').toString() === 'true';
			const $currentAnswer = $faqAnswers.filter(
				`[data-question=${currentQuestionId}]`,
			);
			const currentMinHeight = $currentAnswer.outerHeight();

			// Toggle questions and answers
			$faqQuestions
				.attr({
					'aria-expanded': false,
				})
				.filter($currentQuestion)
				.attr({
					'aria-expanded': !currentQuestionExpanded,
				});
			$faqAnswers
				.attr({
					'aria-hidden': true,
				})
				.filter($currentAnswer)
				.attr({
					'aria-hidden': currentQuestionExpanded,
				});

			// If the current question is the same as the last one that was clicked...
			if (lastQuestionId === currentQuestionId) {
				// If it's open, close it... Or if it's closed, open it
				if (currentQuestionExpanded) {
					$faq.css('min-height', 0);
				} else {
					$faq.css('min-height', currentMinHeight);
				}
			} else {
				// Otherwise, the current question is a new question so set it's height as the current height
				$faq.css('min-height', currentMinHeight);
			}

			lastQuestionId = currentQuestionId;
		});
	});
})();
